export const JobStatus = {
    Started: 'Started',
    Completed: 'Completed',
    Paused: 'Paused',
}

export const JobStatusFR = {
    Started: 'Commencé',
    Completed: 'Terminé',
    Paused: 'En attente',
}

export const JobStatusList = [JobStatus.Started, JobStatus.Completed, JobStatus.Paused]